import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import NormalPricing from './components/NormalPricing';
import PremiumServices from './components/PremiumServices';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ServiceArea from './components/ServiceArea';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <ServiceArea />
      <NormalPricing />
      <PremiumServices />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
